export default {
  open: false,
  creatingShipmentDialog: false,
}
